/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 汎用システム定数情報マスターテーブル（OT_PCUTHAN）のキャッシュ値
 */
export interface ConstSystemCodeInfoMstDto { 
    /**
     * システム定数コードシーケンス番号
     */
    sysdefCodeSqcno?: string;
    /**
     * システム定数設定値テキスト
     */
    sysdefSupvalText?: string;
    /**
     * システム定数内容テキスト
     */
    sysdefContText?: string;
    /**
     * システム定数コメント情報テキスト
     */
    comentInfoText?: string;
}

